
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {WorkFlowStageModel} from '../dto/work-flow-stage-model';
import {AppConfig} from '../common/app.config';

@Injectable({
  providedIn: 'root'
})
export class WorkflowStageService {
  private BASE_URL = this.appConfig.getConfig('BASE_URL') + 'api/';

  constructor(private http: HttpClient, private appConfig: AppConfig) { }

  public getAllWorkflowStages(): Observable<Array<WorkFlowStageModel>> {
    return this.http.get<Array<WorkFlowStageModel>>(this.BASE_URL + 'workflowStage/');
  }
}
